<template>
    <div>
        <div class="page-heading">
            <slot name="title" :active-item="activeItem">
            </slot>
                <!-- <h2 class="display-4 montserrat-bold text-capitalize" v-text="activeItem.title"></h2> -->
            <card-navigation :items="items" :active-item="activeItem"></card-navigation>

            <slot name="body" :active-item="activeItem"></slot>
        </div>
    </div>
</template>
<script>
import CardNavigation from "./CardNavigation";

export default {
    name: "CardStepperWrapper",

    components: { CardNavigation },
    
    data: () => ({
        activeItem: {},
        currentIndex: 0,
    }),

    methods: {
        setItem(index) {
            this.currentIndex = index;
            this.activeItem = this.items[index];
        },
    },

    props: {
        items: Array,
    }
}
</script>